<template lang="pug">

  span {{ formattedType }}:
    | &nbsp;
    span.number {{ formattedValue }}

</template>

<script>
  export default {
    name: 'ScoreItem',
    props: {
      value: {
        type: Number,
        required: true
      },
      type: {
        type: Number,
        required: true
      }
    },
    computed: {
      formattedValue() {
        let type = this.getTypeName(this.type);
        let value = Math.round(this.value * this.$store.state.modificator[type]);

        if(type === "money" || type === "time") {
          return (value > 0 && value !== 0) ? `-${value}` : value;
        } else {
          return (value > 0 && value !== 0) ? `+${value}%` : value;
        }
      },
      formattedType() {

        let typeNameFormatted = "";

        switch(this.getTypeName(this.type)) {
          case "money":
            typeNameFormatted = "Деньги";
            break;
          case "time":
            typeNameFormatted = "Время";
            break;
          case "pain":
            typeNameFormatted = "Боль";
            break;
        }

        return typeNameFormatted;
      }
    },
    methods: {
      getTypeName(type) {
        return this.$store.state.constants.scoreTypes[type];
      }
    }
  }
</script>

<style scoped lang="stylus">
  span
    flex 1 0 auto
    height 2rem
    line-height 2rem
    @media $tablet
      height 4rem
      line-height 4rem
  .number
    font-size 1.6rem
    font-weight 700
    @media $tablet
      font-size 2.4rem
</style>
